import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { isItemInCart } from 'selectors/cartSelectors';
import { addItemToCart, removeItemFromCart } from 'reducers/cartReducer';

import { getPropertyDocuments } from 'utils/propertyDocuments';
// import { openModal } from 'reducers/modalReducer';
// import { MODAL_TYPES } from 'view/ModalManager';
import Spinner from 'components/Spinner';

import './PropertyDocumentsList.css'

function DocumentRow ({ documentName, isDisabled, isCompact }) {
	const dispatch = useDispatch();
	const {
		propertyId,
		address,
		isInCart,
	} = useSelector(state => ({
		propertyId: state.property.propertyData?.id,
		address: state.property.propertyData?.address,
		isInCart: isItemInCart(state, state.property.propertyData?.address, documentName),
	}));
	
	if (isDisabled) {
		return <div><span className="link-disabled">{documentName}</span></div>;
	}

	// const openAddToCartModal = () => {
	// 	return dispatch(openModal(MODAL_TYPES.ADD_TO_CART, { documentName }));
	// };

	const addToCart = () => dispatch(addItemToCart({ address, documentName, propertyId }));
	const removeFromCart = () => dispatch(removeItemFromCart(address, documentName));

	const toggleCart = () => {
		if (isInCart) {
			removeFromCart();
		} else {
			addToCart();
		}
	}

	return (
		<div className={`document-row ${isCompact ? 'is-compact' : ''}`}>
			<span className="doc-name">{documentName}</span>
			<span>
				<button className={`btn btn-${isInCart ? 'danger' : 'primary'}`} onClick={toggleCart}>
					{isInCart ? 'Remove from cart' : 'Request'}
				</button>
			</span>
		</div>
	);

	// return (
	// 	<button className="btn-hyperlink" disabled={props.areLinksDisabled} onClick={() => openAddToCartModal(documentName)}>
	// 		{documentName}
	// 	</button>
	// );
}

function PropertyDocumentsList(props) {
	const [selectedCategory, setSelectedCategory] = useState(props.selectedCategory || 'Property Records & Documentation');
	const [searchTerm] = useState('');

	const dispatch = useDispatch();
	const {
		propertyId,
		address,
		isLoading,
		documents,
	} = useSelector(state => ({
		propertyId: state.property.propertyData?.id,
		address: state.property.propertyData?.address,
		isLoading: state.property.isLoading,
		documents: getPropertyDocuments(state.property.propertyData),
	}));

	const categories = [
		'Property Records & Documentation',
		'Structural & Construction',
		'Fire',
		'Mechanical, Plumbing & Fuel',
		'Energy, Environment & Health',
		'Housing, Tenant & HPD',
		'Special Inspections & Progress',
		'Other / General Compliance',
	];

	// Use prop category if provided, otherwise use internal state
	const currentCategory = props.selectedCategory || selectedCategory;
	const selectedDocs = documents[currentCategory] || [];
	const filteredDocs = selectedDocs.filter(doc =>
		doc.toLowerCase().includes(searchTerm.toLowerCase())
	);

	const handleDocumentSelect = (documentName) => {
		if (props.onSelectDocument) {
			props.onSelectDocument(documentName);
		} else {
			// Add to cart directly
			dispatch(addItemToCart({ address, documentName, propertyId }));
		}
	};

	const addToCart = (documentName) => {
		dispatch(addItemToCart({ address, documentName, propertyId }));
	};

	if (props.showOnlySelected && props.selectedDocument) {
		return (
			<div className="property-document-list">
				<DocumentRow
					documentName={props.selectedDocument}
					isDisabled={false}
					isCompact={false}
				/>
			</div>
		);
	}

	if (props.showAsList) {
		return (
			<div className="documents-list">
				{filteredDocs.map(documentName => (
					<DocumentRow
						key={documentName}
						documentName={documentName}
						isDisabled={false}
						isCompact={false}
					/>
				))}
			</div>
		);
	}

	// If props are provided, use the old behavior
	if (props.selectedCategory || props.onSelectDocument) {
		return (
			<div className="data-sets-list">
				{isLoading && <Spinner />}
				{selectedDocs.map(documentName => (
					<div key={documentName} className={`data-set-link-wrapper ${props.selectedDocument === documentName ? 'is-selected' : ''}`}>
						<button className="btn-hyperlink" onClick={() => handleDocumentSelect(documentName)}>
							<span>
								<span>{documentName}</span>
							</span>
						</button>
					</div>
				))}
			</div>
		);
	}

	// Default: 2-panel layout
	return (
		<div className="rd-overview-data-sets-card-vertical-content">

			{/* Two panel layout */}
			<div className="rd-overview-data-sets-card-vertical-list-wrapper">
				<div className="documents-categories-list">
					{categories.map((category) => (
						<div
							key={category}
							className={`documents-category-item ${selectedCategory === category ? 'is-selected' : ''}`}
							onClick={() => setSelectedCategory(category)}
						>
							{category}
						</div>
					))}
				</div>
			</div>

			<div className="rd-overview-data-sets-card-vertical-table-wrapper">
				<div className="documents-content-panel">
					<h5 className="documents-category-title">{selectedCategory}</h5>
					{isLoading ? (
						<Spinner />
					) : (
						<div className="documents-list-table">
							{filteredDocs.length > 0 ? (
								filteredDocs.map(documentName => (
									<div key={documentName} className="document-item-row">
										<span className="document-name">{documentName}</span>
										<button
											className="btn btn-primary btn-sm"
											onClick={() => addToCart(documentName)}
										>
											Request
										</button>
									</div>
								))
							) : (
								<p className="no-documents">No documents found in this category.</p>
							)}
						</div>
					)}
				</div>
			</div>
		</div>
	);
}

export default PropertyDocumentsList;
